import Application from "../../Application";
import { IIndexTypeGroupService } from "../service/IndexGroupService";

export default class AssignGroupItemsInteractor {
  private application: Application;
  private indexTypeGroupService: IIndexTypeGroupService;

  constructor({ application, indexTypeGroupService }: any) {
    this.application = application;
    this.indexTypeGroupService = indexTypeGroupService;
  }

  async execute(groupId: number, typeIds: number[]) {
    return this.indexTypeGroupService.addItemsToIndexTypeGroup(
      groupId,
      typeIds
    );
  }
}
